<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g clip-path="url(#clip0_8706_13637)">
      <path
        d="M11.5 0L12.2858 2.41844H14.8287L12.7714 3.91312L13.5572 6.33156L11.5 4.83688L9.44275 6.33156L10.2286 3.91312L8.1713 2.41844H10.7142L11.5 0Z"
        fill="#394B5A"
        fill-opacity="0.8"
      />
      <path
        d="M11.5 17L12.2858 19.4184H14.8287L12.7714 20.9131L13.5572 23.3316L11.5 21.8369L9.44275 23.3316L10.2286 20.9131L8.1713 19.4184H10.7142L11.5 17Z"
        fill="#394B5A"
        fill-opacity="0.8"
      />
      <path
        d="M20.5 8L21.2858 10.4184H23.8287L21.7714 11.9131L22.5572 14.3316L20.5 12.8369L18.4428 14.3316L19.2286 11.9131L17.1713 10.4184H19.7142L20.5 8Z"
        fill="#394B5A"
        fill-opacity="0.8"
      />
      <path
        d="M3.5 8L4.2858 10.4184H6.8287L4.77145 11.9131L5.55725 14.3316L3.5 12.8369L1.44275 14.3316L2.22855 11.9131L0.171302 10.4184H2.7142L3.5 8Z"
        fill="#394B5A"
        fill-opacity="0.8"
      />
      <path
        d="M5.5 2L6.2858 4.41844H8.8287L6.77145 5.91312L7.55725 8.33156L5.5 6.83688L3.44275 8.33156L4.22855 5.91312L2.1713 4.41844H4.7142L5.5 2Z"
        fill="#394B5A"
        fill-opacity="0.8"
      />
      <path
        d="M17.5 2L18.2858 4.41844H20.8287L18.7714 5.91312L19.5572 8.33156L17.5 6.83688L15.4428 8.33156L16.2286 5.91312L14.1713 4.41844H16.7142L17.5 2Z"
        fill="#394B5A"
        fill-opacity="0.8"
      />
      <path
        d="M17.5 15L18.2858 17.4184H20.8287L18.7714 18.9131L19.5572 21.3316L17.5 19.8369L15.4428 21.3316L16.2286 18.9131L14.1713 17.4184H16.7142L17.5 15Z"
        fill="#394B5A"
        fill-opacity="0.8"
      />
      <path
        d="M5.5 15L6.2858 17.4184H8.8287L6.77145 18.9131L7.55725 21.3316L5.5 19.8369L3.44275 21.3316L4.22855 18.9131L2.1713 17.4184H4.7142L5.5 15Z"
        fill="#394B5A"
        fill-opacity="0.8"
      />
    </g>
    <defs>
      <clipPath id="clip0_8706_13637">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
